import { fetcherIgnore404 } from "@/lib/utils";
import { useSession } from "@/components/useSession";
import { CurrentUser, JSONSafe } from "@/types";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import useSWR, { mutate } from "swr";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const TenantSwitchTracker = () => {
  const { data: session, update } = useSession();
  const { data: user } = useSWR<JSONSafe<CurrentUser>>("/api/user", fetcherIgnore404);
  const [teamChanged, setTeamChanged] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (!user || !session?.user) {
      return;
    }
    if (user.tenantId === session.user.tenantId) {
      return;
    }
    setTeamChanged(true);
  }, [user?.tenantId, session?.user, user]);

  const handleReloadTeam = async () => {
    setTeamChanged(false);
    await update();
    await mutate(() => true, undefined, { revalidate: true });
    router.replace("/dashboard");
  };

  // Dismissing the dialog any way (Esc, overlay click, or the Reload button)
  // reloads for the current team.
  const handleTeamDialogChange = (open: boolean) => {
    if (!open) {
      handleReloadTeam();
    }
  };

  return (
    <Dialog open={teamChanged} onOpenChange={handleTeamDialogChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Your active team changed</DialogTitle>
          <DialogDescription>
            Your active team was changed in another session. Reload to continue with your
            current team.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleReloadTeam}>Reload</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
